import RotateIcon from "../../../../media/rotate.svg"
import ScrollIcon from "../../../../media/scroll.svg"
import ArHighlightIcon from "../../../../media/AR_Highlight.svg"
import ArIcon from "../../../../media/ar.svg"
import SwipeIcon from "../../../../media/swipe.svg"
import PinchIcon from "../../../../media/pinch.svg"
import ArPhoneIcon from "../../../../media/AR_Phone.svg"
import SunIcon from "../../../../media/sun.svg"

const OnboardingIcon = ({iconName}) => {
  const icons = {
    rotate: RotateIcon,
    scroll: ScrollIcon,
    arHighlight: ArHighlightIcon,
    swipe: SwipeIcon,
    pinch: PinchIcon,
    arPhone: ArPhoneIcon,
    ar: ArIcon,
    sun: SunIcon,
  };

  const getIcon = (iconName) => {
    return icons[iconName];
  };

  return <img src={getIcon(iconName)} alt="AR Icon" className="ar-icon"></img>
}
 
export default OnboardingIcon;